var _path, _path2, _path3;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgStarHalfIcon(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Estrella",
    xmlns: "http://www.w3.org/2000/svg",
    width: 18.02,
    height: 17.119,
    viewBox: "0 0 18.02 17.119",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "Icon_material-star",
    "data-name": "Icon material-star",
    d: "M12.01,16.758l5.568,3.361L16.1,13.785,21.02,9.523l-6.478-.55L12.01,3,9.478,8.974,3,9.523l4.919,4.262L6.442,20.119Z",
    transform: "translate(-3 -3)",
    fill: "#b3cc1d",
    opacity: 0
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    id: "Icon_material-star-half",
    "data-name": "Icon material-star-half",
    d: "M21.02,9.523l-6.478-.559L12.01,3,9.478,8.974,3,9.523l4.919,4.262L6.442,20.119l5.568-3.361,5.568,3.361L16.11,13.785Zm-9.01,5.55V6.694l1.541,3.64,3.946.342-2.991,2.595.9,3.856Z",
    transform: "translate(-3 -3)",
    fill: "#b3cc1d"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    id: "Icon_material-star-border",
    "data-name": "Icon material-star-border",
    d: "M21.02,9.523l-6.478-.559L12.01,3,9.478,8.974,3,9.523l4.919,4.262L6.442,20.119l5.568-3.361,5.568,3.361L16.11,13.785Zm-9.01,5.55L8.622,17.119l.9-3.856L6.532,10.668l3.946-.342L12.01,6.694l1.541,3.64,3.946.342-2.991,2.595.9,3.856Z",
    transform: "translate(-3 -3)",
    fill: "#b3cc1d"
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgStarHalfIcon);
export default __webpack_public_path__ + "static/media/star-half-icon.871d8bba12ca1926507af1320ba45f78.svg";
export { ForwardRef as ReactComponent };